(function () {
    'use strict';

    // Make thumbnail clickable

    $('.mol-intro-media .intro-media-video .atm-play').on(
        'click',
        function (e) {
            e.stopPropagation();
        }
    );

    $('.mol-intro-media .intro-media-video').on('click', function (e) {
        $(this).find('.atm-play').trigger('click');
    });
})();

// Video Player Basic Functionality
$(document).ready(function () {
    $('.mol-video-player').each(function () {
        const $player = $(this);
        const video = $player.find('video')[0];
        const $playButton = $player.find('.atm-play');

        if (video && $playButton.length) {
            const $icon = $playButton.find('.atm-icon');
            
            function updatePlayButton() {
                if (video.paused) {
                    $icon.removeClass('fa-pause').addClass('fa-play-circle');
                } else {
                    $icon.removeClass('fa-play-circle').addClass('fa-pause');
                }
            }
            
            $playButton.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            });
            
            // Listen to video events to update button
            $(video).on('play pause', updatePlayButton);
            
            // Initial state
            updatePlayButton();

            $(video).css('cursor', 'default');
        }
    });
});
